/**
 * Languages a session report can be translated into.
 * The session primary language is the original and is never a target.
 */

export const REPORT_TRANSLATION_LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'French' },
];

export function getReportTranslationLanguageName(code) {
  const match = REPORT_TRANSLATION_LANGUAGES.find((l) => l.code === code);
  return match?.name || code?.toUpperCase() || code;
}

export function availableTranslationLanguages(primaryLanguage = 'en') {
  const primary = String(primaryLanguage || 'en').toLowerCase();
  return REPORT_TRANSLATION_LANGUAGES.filter((l) => l.code !== primary);
}
